import $ from 'jquery';

$(document).ready(function () {
  acfCaseStudiesBlock();
});

function acfCaseStudiesBlock() {
  $('.js-acf-case-studies-block').each(function () {});
}
